import './TestsList.css'
import TableHead from "../../../components/utilities/table/TableHead";
import PageLayout from "../../../layout/page-layout/PageLayout";
import Table from "../../../components/utilities/table/Table";
import TableBody from "../../../components/utilities/table/TableBody";
import {useEffect, useState, useContext, useRef} from "react";
import TableRow from "../../../components/utilities/table/TableRow";
import {Button} from "react-bootstrap";
import FlexBox from "../../../components/utilities/FlexBox";

import SearchBar from "../../../components/search/SearchBar";
import axios from "axios";
import Loader from "../../../components/utilities/Loader";
import {APP_URL_PREFIX} from "../../../utilities//Constants";
import {getCandidateFullName} from "../../../utilities/Utilities";
import {
    CustomErrorToast,
    CustomLoadingToast,
    CustomToastContainer, DismissToast, updateCustomErrorToast,
    updateCustomSuccessToast
} from "../../../components/utilities/CustomToast";
import {sendTestToCandidate, sendTestToNewCandidate} from "../../../components/send-test/SendTest";
import {ArrowDown, ArrowDownShort, ArrowUpShort, CaretDown, CaretUp, X} from "react-bootstrap-icons";
import newCandidateArrow from "../../../assets/tests-list/newCandidateArrow.svg";
import ConfirmModal from "../../../components/utilities/ConfirmModal";
import CompanyTeamContext from "../../../CompanyTeamContext";
import Tooltip from "../../../components/utilities/Tooltip";
import ClickableTooltip from "../../../components/utilities/ClickableTooltip";
import {Link, useNavigate} from "react-router-dom";
import {API_URL_PREFIX, TEST_BUILDER_PRIVILEGE} from "../../../utilities/Constants";
import {QuestionsExplorer} from "../test-new-view/TestBuilder";
import Status from "../../../components/quiz-result/Status";
import Pagination from "../../../components/utilities/Pagination";
import GradientButton from "../../../components/utilities/gradient-button/GradientButton";
import ScheduleCheckbox from "../../../components/send-test/ScheduleCheckbox";
import Divider from "../../../components/utilities/Divider";
import ReactTooltip from "react-tooltip";

// Import SVG assets for mobile
import timeIcon from '../../../assets/tests-list/timeForTest.svg';
import questionsIcon from '../../../assets/tests-list/numOfQuestions.svg';
import dateIcon from '../../../assets/tests-list/lastModified.svg';
import sendTestIcon from '../../../assets/candidate-profile/sendTestiInvitation.svg';
import searchIcon from '../../../assets/candidate-profile/searchCandidates.svg';

const PAGE_SIZE = 15;

const TestsList = () => {
    const [totalPredefinedTests, setTotalPredefinedTests ] = useState(0)
    const [totalCompanyTests, setTotalCompanyTests] = useState(0)
    const [page, setPage] = useState(0)
    const [tests, setTests] = useState()
    const [candidates, setCandidates] = useState([])
    const [loader, setLoader] = useState(true)
    const [keyword, setKeyword] = useState("")
    const [previewTest, setPreviewTest] = useState({})
    const [showPreview, setShowPreview] = useState(false)
    const [searchMode, setSearchMode] = useState(false)
    const company = useContext(CompanyTeamContext)


    const refresh = (forceRefresh) =>{
        if(!candidates || candidates.length === 0 || forceRefresh) {
            axios.get(API_URL_PREFIX+"/GetAllCandidates.html?limit=500&offset=0")
                .then(e=>{
                    let data = e.data;
                    if(data && !data.err){
                        setCandidates(e.data)
                    }
                })
                .catch(err=>{
                    console.log(err)
                })
        }
    }

    useEffect(
        () => {
            if(!candidates || candidates.length === 0){
                refresh(true)
            }
        }
        ,[tests])

    useEffect(()=>{
        if(!searchMode){
            // go back to normal pagination mode
            countTests()
            getTests(PAGE_SIZE, page * PAGE_SIZE)
        }

    }, [searchMode]);

    useEffect(() => {
        return () => {
            setPage(0)
        }
    }, []);

    useEffect(() => {
        if(searchMode) return;
        getTests(PAGE_SIZE, page * PAGE_SIZE)
    }, [page]);

    const countTests = () => {
        if(searchMode) return;
        setLoader(true)
        axios.get(  API_URL_PREFIX+"/CountCompanyLiteTests.html")
            .then(response => {
                setLoader(false)
                debugger;
                setTotalCompanyTests(response.data.countCompany || 0)
                setTotalPredefinedTests(response.data.countPredefined || 0)
            })
            .catch(e => {
                setLoader(false)
                if(e.response.status == 403){
                    CustomErrorToast("Permission Denied!")
                }
                else{
                    CustomErrorToast("Error fetching tests, Please try again.")
                }
            })
    }




    const getTests = (limit, offset, keyword, searchMode = false) => {
        const sentPage = page + ''
        setLoader(true)
        let url = API_URL_PREFIX+"/GetCompanyLiteTests.html";
        if(!keyword && limit !== undefined && offset !== undefined){
            url += "?limit="+limit+"&offset="+offset
        }
        if(keyword){
            url += (url.includes("?") ? "&" : "?") + "keyword="+encodeURIComponent(keyword)
        }
        axios.get(url)
            .then(response => {
                setLoader(false)
                if(!searchMode && sentPage !== page + '') {
                    return; // If the page has changed while fetching, ignore this response
                }
                if (response.data.err) {
                    CustomErrorToast("Permission Denied!")
                } else {
                    setTests(response.data.sort(  (a,b) =>{
                        if(a.predefinedTest == b.predefinedTest){
                            return b.lastModified - a.lastModified;
                        }
                        else{
                            return a.predefinedTest - b.predefinedTest
                        }
                    }
                    ))


                    if(searchMode){
                        setTotalCompanyTests(response.data.length);
                        setTotalPredefinedTests(0)
                    }
                }
            })
            .catch(e => {
                setLoader(false);
                if (e.response.status == 403) {
                    CustomErrorToast("Permission Denied!")
                } else {
                    CustomErrorToast("Error fetching tests, Please try again.")
                }

            })
    }

    useEffect(() => {
        if(company){
            document.title  = "Test Library - " + company.basicTitle
        }
        if(!tests){
            countTests()
            getTests(PAGE_SIZE, page * PAGE_SIZE)
        }
        else {
            setLoader(false)
        }

        return () => {
            setPage(0)
            if(company){
                document.title = company.basicTitle
            }
        }
    }, [company])

    const getPreviewTest = (testId)=>{
        const id = CustomLoadingToast("Loading...")
        axios.get(API_URL_PREFIX+"/GetCompanyLiteTestPreview.html?id="+testId)
        .then(e=>{
            let data = e.data;
            if(data && !data.err){
                setPreviewTest(data)
                setShowPreview(true)
                DismissToast(id);
            }
            else{
                if(data.info){
                    updateCustomErrorToast(data.info,id)
                }
                else{
                    updateCustomErrorToast("Preview Error.",id)
                }
            }
        })
        .catch(err=>{
            updateCustomErrorToast("Preview Error.",id)
        })
    }

    let filteredList = tests ? tests : [];

    const search = e=>{
        if(!keyword || keyword.length < 3){
            CustomErrorToast("Please enter at least 3 characters to search.")
        }
        else {
            setSearchMode(true)
            setPage(0);
            getTests(undefined, undefined, keyword, true);
        }
    }

    return (<PageLayout  height={"100%"} pageClassName="tests-list-page-wrapper">
        {showPreview && previewTest && previewTest.quizQuestions && <QuestionsExplorer  testTime={previewTest.timePerQuiz} testName={previewTest.name} isViewOnly={true} questions={previewTest.quizQuestions} setLoader={false} setQuestions={()=>{}} setShowQuestionsExplorer={setShowPreview} /> }

        <Loader loader={loader}/>
        {/* Desktop Layout */}
        <div className="tests-desktop" style={{justifyContent: "top", display: "flex",height:"100%", width: "100%", flexDirection: "column", padding: "30px"}}>
            <FlexBox style={{width:"100%"}} justify={"space-between"}>
                <h3 style={{color: "#364454", fontWeight: "700", fontSize: "20px"}}>Tests Library</h3>
                <div className="tests-desktop-search-container">
                    <div className="tests-desktop-search-wrapper">
                        {keyword && (
                            <button
                                className="tests-desktop-search-clear"
                                onClick={() => {
                                    setSearchMode(false);
                                    setKeyword("");
                                }}
                            >
                                ✕
                            </button>
                        )}
                        <input
                            className="tests-desktop-search-input"
                            value={keyword}
                            onChange={e=>setKeyword(e.target.value)}
                            placeholder="Search by Test Name"
                            onKeyDown={e => {
                                if (e.key === 'Enter') {
                                    search();
                                }
                            }}
                        />
                        <button
                            className="tests-desktop-search-button"
                            onClick={search}
                        >
                            <img src={searchIcon} alt="Search" />
                        </button>
                    </div>
                </div>

            </FlexBox>
            <br/>
            <div className={"table-wrapper"}>
                <Table id={"testsTable"}>
                    <TableHead columns={["Test Name", "Duration", "Questions", "Last Modified", "", "", "", ""]}/>
                    <TableBody>
                        { !loader && (!tests || filteredList.length == 0)
                            && <tr><td style={{verticalAlign:"middle", color:"#bababa", textAlign:"center"}} rowSpan={5} colSpan={6}>No Tests Found.</td></tr> }
                        {filteredList.map((test, i) => {
                            return (<TestRow refresh={()=>refresh(true)} getPreviewTest={getPreviewTest} setTests={setTests} candidates={candidates} setCandidates={setCandidates} i={i} test={test}/>)
                        })}
                    </TableBody>
                </Table>
            </div>
            <FlexBox justify={"space-between"} align={"end"} style={{marginTop: "10px"}}>
                <div style={{
                    fontSize: "12px",
                    textAlign: "left"
                }}>{totalCompanyTests + totalPredefinedTests} Tests
                </div>
                {searchMode ? <div></div> : <Pagination currentPage={page} onPageChange={setPage}
                                                               totalPages={Math.ceil(totalPredefinedTests / PAGE_SIZE)} style={{marginTop: "10px"}}/>}

            </FlexBox>

        </div>

        {/* Mobile Layout */}
        <FlexBox className="tests-mobile" style={{display: "none", flexDirection: "column", width: "100%"}}>
            <h3 className="tests-mobile-title" style={{color: "#364454", fontWeight: "700", fontSize: "20px", marginBottom: "20px"}}>Tests Library</h3>

            <div className="tests-mobile-search-container">
                <div className="tests-mobile-search-wrapper">
                    {keyword && (
                        <button
                            className="tests-mobile-search-clear"
                            onClick={() => {
                                setSearchMode(false);
                                setKeyword("");
                            }}
                        >
                            ✕
                        </button>
                    )}
                    <input
                        className="tests-mobile-search-input"
                        value={keyword}
                        onChange={e=>setKeyword(e.target.value)}
                        placeholder="Search by Test Name"
                        onKeyDown={e => {
                            if (e.key === 'Enter') {
                                search();
                            }
                        }}
                    />
                    <button
                        className="tests-mobile-search-button"
                        onClick={search}
                    >
                        <img src={searchIcon} alt="Search" />
                    </button>
                </div>
            </div>

            <MobileTestsList tests={filteredList} loader={loader} refresh={()=>refresh(true)} getPreviewTest={getPreviewTest} setTests={setTests} candidates={candidates} setCandidates={setCandidates} />

            <FlexBox className="tests-mobile-footer" justify={"space-between"} align={"center"} style={{padding: "0 5vw", marginTop: "20px"}}>
                <div style={{fontSize: "12px", textAlign: "left"}}>{totalCompanyTests + totalPredefinedTests} Tests</div>
                {searchMode ? <div></div> : <Pagination currentPage={page} onPageChange={setPage}
                            totalPages={Math.ceil(totalPredefinedTests / PAGE_SIZE)} style={{marginTop: "10px"}}/>}
            </FlexBox>
        </FlexBox>
    </PageLayout>)
}

function TestRow({setTests, test, candidates, i, getPreviewTest, setCandidates, refresh}) {
    const [show, setShow] = useState(false)
    const [showConfirmDelete, setShowConfirmDelete ] = useState(false)
    const [privileges, setPrivileges] = useState([])
    const company = useContext(CompanyTeamContext)
    const navigate = useNavigate()

    useEffect(()=>{
        if(company && company.privileges){
            setPrivileges(company.privileges);
        }
    },[company])


    const deleteTest = ()=>{

        const id = CustomLoadingToast("Deleting...")
        axios.delete(API_URL_PREFIX+"/DeleteTest.html?id="+test.key)
            .then(e=>{
                let data = e.data;
                if(data && !data.err){
                    setTests(tests=>tests.filter(e=>e.key!=test.key))
                    updateCustomSuccessToast("Deleted",id)
                }
                else{
                    updateCustomErrorToast(data.info,id)
                }
                setShowConfirmDelete(false)
            })
            .catch(err=>{
                setShowConfirmDelete(false)
                try {
                    const errorResponse = JSON.parse(err);
                    const errorMessage = errorResponse.info;
                    updateCustomErrorToast(errorMessage,id);
                } catch (e) {
                    console.log(err);
                }
            })
    }
    if(test.predefinedTest){
        return <TableRow>
            <td style={{fontWeight:"bold"}}>{getTestName(test)}</td>

            <td>{test.timePerQuiz === 0 ? "No Time Limit" : test.timePerQuiz}</td>
            <td style={{textAlign: "left", paddingLeft: "35px"}}>{test.amountOfQuestions}</td>
            <td>{new Date(test.lastModified).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</td>
            <td>
            <span style={{position: "relative"}}>
                <Button onClick={event => setShow(!show)} style={{fontWeight: "700", position: "relative"}}
                        variant={"outline-primary"}>Send to</Button>
                <SendTo refresh={()=>refresh(true)} setShow={setShow} show={show} test={test} candidates={candidates} setCandidates={setCandidates}/>
            </span>
            </td>
            <td >
                    <FlexBox style={{ cursor: "pointer", position: "relative", fontWeight: "bold" }} justify={"center"} align={"center"}>
                    <ClickableTooltip
                        key={test.key}
                        id={"desc-tooltip-" + test.key}
                        fetchText={() =>
                            axios
                                .get(API_URL_PREFIX + "/GetCompanyLiteTests.html?testId=" + test.key)
                                .then(res => res?.data?.predefinedTestDescription?.value || "No description found.")
                                .catch(() => "Error loading description.")
                        }
                    />
                    &nbsp;Description
                </FlexBox>
            </td>
            <td><Button onClick={e=>getPreviewTest(test.key)}>{privileges.includes(TEST_BUILDER_PRIVILEGE) ? "Preview" : "Example Question" }</Button></td>
        </TableRow>
    }
    return <TableRow>
        {privileges.includes(TEST_BUILDER_PRIVILEGE) ?

            <td><Link className={"candidate-link"} to={APP_URL_PREFIX + "/test/" + test.key}>{getTestName(test)}</Link></td>
        :
            <td style={{fontWeight:"bold"}}>{getTestName(test)}</td>
        }

        <td>{test.timePerQuiz === 0 ? "No Time Limit" : test.timePerQuiz}</td>
        <td style={{textAlign: "left", paddingLeft: "35px"}}>{test.amountOfQuestions}</td>
        <td>{new Date(test.lastModified).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</td>
        <td>
            <span style={{position: "relative"}}>
                <Button onClick={event => setShow(!show)} style={{fontWeight: "700", position: "relative"}}
                        variant={"outline-primary"}>Send to</Button>
                <SendTo refresh={refresh} setShow={setShow} show={show} test={test} candidates={candidates} setCandidates={setCandidates}/>
            </span>
        </td>
        <td style={{fontWeight:"bold", textAlign:"center"}}>
            &nbsp;Custom Test
        </td>
        <td>
            <Button onClick={() => navigate("/Benchmark?quizName="+encodeURIComponent(test.name)+"&companyKey="+encodeURIComponent(company.key))} variant={"outline-primary"}>Benchmark</Button>
        </td>
        <td>
            <FlexBox style={{cursor: "pointer", position: "relative"}} justify={"center"} align={"center"}>
                <Button onClick={() => setShowConfirmDelete(true)} variant={"outline-danger"}><X/> Delete</Button>
            </FlexBox>

        </td>
        {showConfirmDelete
            && <ConfirmModal variant={"danger"} show={showConfirmDelete} setShow={setShowConfirmDelete}
                             callback={deleteTest} body={"Are you sure you want to delete "+test.name+" test?"}
                             title={"Confirm Delete"} yes={"Delete"} no={"Cancel"}
                             fallback={e=>setShowConfirmDelete(false)}  />}
    </TableRow>;
}

const SendTo = ({test, candidates, setCandidates, show, setShow, refresh}) => {
    const [keyword, setKeyword] = useState("")
    const [sentStatus, setSentStatus] = useState({})

    const [scheduled, setScheduled] = useState(false)
    const [scheduledDate, setScheduledDate] = useState(
        new Date(new Date().setDate(new Date().getDate() + 1) - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .slice(0, 16)
    );

    const company = useContext(CompanyTeamContext) || {}
    let refreshQuota = company.refresh
    const ref = useRef();

    const mouseOutHandle = e=>{
        setShow(show =>{
            if(show){
                if(ref.current && !ref.current.contains(e.target)){
                    return false;
                }
            }
            return show;
        })
    }

    useEffect(()=>{
        document.addEventListener('mousedown',mouseOutHandle)
        return (()=>{
            document.removeEventListener('mousedown',mouseOutHandle)
        })
    },[])

    return (
        <>
            {show && <div className="sendto-modal-backdrop" onClick={() => setShow(false)}></div>}
            <FlexBox refVar={ref} hidden={!show} direction={"column"} justify={"start"} align={"start"}
                         className={"soft-shadow " + (show ? "transformToShow" : "transformToHide")}
                         style={{
                             position: "absolute",
                             top: "-7px",
                             right: "83px",
                             background: "#fff",
                             width: "400px",
                             height:"max-content",
                             padding: "15px",
                             zIndex:5000
                         }}>
            <p style={{fontSize: "15px", fontWeight:"bold"}}>Send {test.name} Test to:</p>
            <SearchBar value={keyword} setValue={e=>setKeyword(e.target.value)} placeHolder={"Search Candidate"} width={"100%"}/>
            <div style={{marginTop: "15px"}}>
                <ScheduleCheckbox
                    scheduled={scheduled}
                    setScheduled={setScheduled}
                    scheduledDate={scheduledDate}
                    setScheduledDate={setScheduledDate}
                    style={{display:"flex", width:"100%", justifyContent:"center"}}
                />
            </div>
            <div className="sendto-candidates-list" style={{minHeight:"100px", overflow:"auto", width:"100%"}}>
            {candidates && candidates.filter(c=>getCandidateFullName(c).toLowerCase().includes(keyword.toLowerCase()))
                .map(c=>{
                    return  <FlexBox style={{width: "100%", padding: "10px 0px", paddingRight:"2px"}} justify={"space-between"} align={"center"}>
                        <div>{getCandidateFullName(c)}</div>
                        {(sentStatus && sentStatus[c.key])
                            ? <Button disabled={true} style={{height: "30px", padding: "2px 7px", display: "flex", alignItems: "center"}} variant={"outline-primary"}>{scheduled? "Scheduled" :"Sent"}</Button>
                            : <Button id="sendTestAction" onClick={e=>sendTestToCandidate(test.key, c,null,null,setSentStatus, refreshQuota, ()=>{}, scheduled, scheduledDate)} style={{height: "30px", padding: "2px 5px", marginRight:"2px", display: "flex", alignItems: "center"}} variant={"primary"}>{scheduled? "Schedule" :"Send"}</Button>}

                    </FlexBox>
                })}
            </div>
            <NewCandidate refresh={refresh} test={test} setShow={setShow} refreshQuota={refreshQuota} scheduled={scheduled} scheduledDate={scheduledDate}  />


        </FlexBox>
        </>
    )
}

export const getTestName = (test, maxLen = -1)=> {
    let name = test.name || test.testName;
    if(maxLen !== -1){
        if(name.length > maxLen){
            name = name.substring(0,maxLen) + "..."
        }
    }
    return <div style={{
        display: "flex",
        alignItems: "center",
    }}>{name} {(test?.isLugoLiveTemplate || test?.isLugoLive) ?
        <Status style={{marginLeft: "10px"}} label={'Live'} status={"default-status"}/> : ""}</div>
}

export const isLiveTestOrQuiz = (test)=> {
    return (test?.isLugoLiveTemplate || test?.isLugoLive);
}

const NewCandidate = ({test, setShow, refreshQuota, refresh, scheduled, scheduledDate}) => {
    const [showNewCandidate, setShowNewCandidate] = useState(false)
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    return (
        <FlexBox direction={"column"} align={"start"} style={{ width:"100%", marginBottom:"10px"}}>
            <Button onClick={e=>setShowNewCandidate(!showNewCandidate)} variant={"link"} style={{height: "30px",fontWeight:"bold", padding: "2px 0px", color:"#544EFF",textDecoration:"underline", display:"flex", alignItems:"center", gap:"8px", alignSelf:"flex-start"}}>
                New Candidate <img src={newCandidateArrow} alt="" style={{transform: showNewCandidate ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s"}} /></Button>
            <FlexBox hidden={!showNewCandidate} direction={"column"} align={"start"} style={{width:"100%"}}>
                <div style={{marginTop:"10px"}}>
                    <div style={{marginBottom:"5px"}}>Name:</div>
                    <input className={"form-control"} value={name} onChange={e=>setName(e.target.value)}/>
                </div>
                <div style={{marginTop:"10px"}}>
                    <div style={{marginBottom:"5px"}}>Email:</div>
                    <input className={"form-control"} value={email} onChange={e=>setEmail(e.target.value)}/>
                </div>
                <br/>
                <div style={{width:"100%",display:"flex",justifyContent:"center"}}>
                    <Button id="sendTestAction" onClick={e=>sendTestToNewCandidate(test.key,{name:name, email: email}, setShow, e=>{
                        setShowNewCandidate(false)
                        setName("")
                        setEmail("")
                        if(refresh) refresh(true)
                    }, null, refreshQuota, scheduled, scheduledDate)} style={{height: "42px",width:"70px", padding: "2px 7px", margin:"0", display: "flex", alignItems: "center", justifyContent: "center"}} variant={"primary"}>Send</Button>
                </div>
            </FlexBox>
        </FlexBox>
    )
}

// Mobile Components
function MobileTestsList({tests, loader, refresh, getPreviewTest, setTests, candidates, setCandidates}) {
    // Hide tooltips on scroll and touch for mobile
    useEffect(() => {
        const hideTooltip = () => {
            ReactTooltip.hide()
        }

        window.addEventListener('scroll', hideTooltip, true)
        window.addEventListener('touchstart', hideTooltip)
        window.addEventListener('touchmove', hideTooltip)

        return () => {
            window.removeEventListener('scroll', hideTooltip, true)
            window.removeEventListener('touchstart', hideTooltip)
            window.removeEventListener('touchmove', hideTooltip)
        }
    }, [])

    // Rebuild tooltips when tests change
    useEffect(() => {
        if (tests && tests.length > 0) {
            setTimeout(() => ReactTooltip.rebuild(), 100)
        }
    }, [tests])

    return (
        <div className="tests-mobile-cards">
            <ReactTooltip className="dashboard-mobile-tooltip" place="top" type="dark" effect="solid" />
            <Loader loader={loader}/>
            {!loader && (!tests || tests.length === 0) && (
                <div style={{textAlign: "center", color: "#bababa", padding: "20px"}}>
                    No Tests Found.
                </div>
            )}
            {tests && tests.map((test, i) => (
                <MobileTestCard
                    key={test.key}
                    test={test}
                    refresh={refresh}
                    getPreviewTest={getPreviewTest}
                    setTests={setTests}
                    candidates={candidates}
                    setCandidates={setCandidates}
                />
            ))}
        </div>
    );
}

function MobileTestCard({test, refresh, getPreviewTest, setTests, candidates, setCandidates}) {
    const [show, setShow] = useState(false);
    const [privileges, setPrivileges] = useState([]);
    const company = useContext(CompanyTeamContext);

    useEffect(()=>{
        if(company && company.privileges){
            setPrivileges(company.privileges);
        }
    },[company])

    return (
        <>
            <div className="test-mobile-card">
                <div className="test-mobile-card-top">
                    <div className="test-mobile-card-header">
                        <div className="test-mobile-card-name-wrapper">
                            <span className="test-mobile-card-name-label">Test Name</span>
                            <div className="test-mobile-card-name">{getTestName(test)}</div>
                        </div>
                        {test.predefinedTest && (
                            <div className="test-mobile-card-badge">
                                Predefined Test
                            </div>
                        )}
                    </div>

                    <div className="test-mobile-card-details">
                        <div className="test-mobile-card-detail-item">
                            <img src={timeIcon} alt="Duration" className="test-mobile-card-icon" />
                            <span className="test-mobile-card-detail-text">{test.timePerQuiz === 0 ? "No Time Limit" : `${test.timePerQuiz} min`}</span>
                        </div>
                        <div className="test-mobile-card-detail-item" data-tip="Last Modified">
                            <img src={dateIcon} alt="Date" className="test-mobile-card-icon" />
                            <span className="test-mobile-card-detail-text">
                                {new Date(test.lastModified).toLocaleDateString('en-US', {
                                    month: 'short',
                                    day: 'numeric',
                                    year: 'numeric'
                                })}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="test-mobile-card-divider"></div>

                <div className="test-mobile-card-bottom">
                    <button
                        className="test-mobile-send-button"
                        onClick={event => setShow(!show)}
                    >
                        <img src={sendTestIcon} alt="Send" className="test-mobile-send-icon" />
                        <span>Send Test</span>
                    </button>
                </div>
            </div>

            {show && <SendTo refresh={refresh} setShow={setShow} show={show} test={test} candidates={candidates} setCandidates={setCandidates}/>}
        </>
    );
}

export default TestsList